import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=02210002&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=02210002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02210002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02210002')) {
      api.createRecord('02210002', component.options)
    } else {
      api.reload('02210002', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=02210002&scoped=true&", function () {
      api.rerender('02210002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O4573992EJmS/JS/comp/GuestBoxKids.vue"
export default component.exports